module.exports = __webpack_public_path__ + "img/select-category-stadistics.8559dbc9.svg";